import { MessageOutlined, PhoneOutlined } from '@ant-design/icons';
import { Badge } from './Badge';

interface ActivityItemProps {
	type: 'call' | 'text';
	title: string;
	subtitle: string;
	time: string;
	borderBottom?: boolean;
}

const ActivityItem = ({ type, title, subtitle, time, borderBottom = true }: ActivityItemProps) => {
	const iconStyles = {
		call: 'bg-blue-50 text-blue-600',
		text: 'bg-green-50 text-green-600',
	};

	return (
		<div
			className={`flex items-center p-5 hover:bg-gray-50 ${borderBottom ? 'border-b border-gray-200' : ''}`}
		>
			<div
				className={`flex items-center justify-center w-10 h-10 rounded-xl text-base mr-4 ${iconStyles[type]}`}
			>
				{type === 'call' ? <PhoneOutlined rotate={0} /> : <MessageOutlined />}
			</div>

			<div className="flex-grow">
				<div className="font-semibold text-gray-800">{title}</div>
				<div className="text-sm text-gray-500">{subtitle}</div>
			</div>

			<div className="text-sm text-gray-500 mr-4">{time}</div>

			<Badge text="Completed" className="bg-green-100 text-green-600 border-none" />
		</div>
	);
};

export { ActivityItem };
